"use client";

import { useEffect, useState } from 'react';
import useIsMobile from '@/app/hooks/useIsMobile';
import Chatting from './chatting';
import ChattingMobile from './chattingMb';

// Client component wrapper for chat box
export default function ChatBoxClient() {
    const isMobile = useIsMobile();
    const [mounted, setMounted] = useState(false);

    // Prevent hydration mismatch
    useEffect(() => {
        setMounted(true);
    }, []);

    if (!mounted) {
        return null;
    }

    return (
        <>
            {isMobile ? (
                <ChattingMobile isMobile={isMobile} />
            ) : (
                <Chatting isMobile={isMobile} />
            )}
        </>
    );
}

